import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Nazwa Ieku "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "flex flex-col items-start justify-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Ilość opakowań "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)

import { useFieldArray, ErrorMessage, Field } from 'vee-validate';


export default {
  __name: 'MedicationField',
  setup(__props) {

const { fields } = useFieldArray('selectedMedications');

return (_ctx, _cache) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, idx) => {
    return (_openBlock(), _createElementBlock("div", {
      key: field.key,
      class: "grid md:grid-cols-2 gap-4"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(Field), {
          name: `selectedMedications[${idx}].title`,
          rules: "required"
        }, {
          default: _withCtx(({ errors, field }) => [
            _createElementVNode("input", _mergeProps(field, {
              type: "text",
              placeholder: "Wpisz nazwę Ieku",
              class: ["form-input", {
                        'border-[1px] !border-error border-solid': errors.length,
                        'border-none': !errors.length,
                    }]
            }), null, 16)
          ]),
          _: 2
        }, 1032, ["name"]),
        _createVNode(_unref(ErrorMessage), {
          name: `selectedMedications[${idx}].title`,
          class: "error-message block text-[15px]"
        }, null, 8, ["name"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(Field), {
          name: `selectedMedications[${idx}].selectedVariant`,
          rules: "required"
        }, {
          default: _withCtx(({ errors, field }) => [
            _createElementVNode("input", _mergeProps(field, {
              type: "text",
              placeholder: "Wpisz liczbę opakowań",
              class: ["form-input", {
                        'border-[1px] !border-error border-solid': errors.length,
                        'border-none': !errors.length,
                    }]
            }), null, 16)
          ]),
          _: 2
        }, 1032, ["name"]),
        _createVNode(_unref(ErrorMessage), {
          name: `selectedMedications[${idx}].selectedVariant`,
          class: "error-message block text-[15px]"
        }, null, 8, ["name"])
      ])
    ]))
  }), 128))
}
}

}